import type { TGetRGDepositResponse, TGetRGTimeoutResponse, TSetRGDepositResponse, TSetRGTimeoutResponse } from '#api';
import { useTypedNuxtApp } from '~/composables/useTypedNuxtApp';

export function useResponsibleGaming() {
  const timeoutTimestamp = ref<number>();

  const getDepositLimit = async (): Promise<TGetRGDepositResponse> => {
    const { $authApi } = useTypedNuxtApp();

    try {
      const sessionKey = await stores.user.getIdToken();
      return await $authApi.post<TGetRGDepositResponse>('/responsiblegaming/getRGDeposite', { sessionKey });
    } catch (error) {
      console.error(error);

      return {
        hasError: true,
        message: error?.message || 'Deposit limit getting failed',
      };
    }
  };

  const setDepositLimit = async (minutesFromNow: number, amount: number): Promise<TSetRGDepositResponse> => {
    const { $authApi } = useTypedNuxtApp();

    try {
      return await $authApi.post<TSetRGDepositResponse>('/responsiblegaming/createRGDeposite', {
        sessionKey: await stores.user.getIdToken(),
        minutesFromNow,
        amount,
      });
    } catch (error) {
      return {
        hasError: true,
        message: error?.message?.toString() || 'Deposit limit setting failed',
      };
    }
  };

  const getPlayTimeout = async (): Promise<TGetRGTimeoutResponse> => {
    const { $authApi } = useTypedNuxtApp();

    try {
      const sessionKey = await stores.user.getIdToken();
      const response = await $authApi.post<TGetRGTimeoutResponse>('/responsiblegaming/getRGTimeout', { sessionKey });

      if (response.hasError === false) {
        timeoutTimestamp.value = response.data?.expiredAt ? new Date(response.data.expiredAt).getTime() : 0;
      }

      return response;
    } catch (error) {
      console.error(error);

      return {
        hasError: true,
        message: error?.message || 'Play timeout getting failed',
      };
    }
  };

  const setPlayTimeout = async (minutesFromNow: number): Promise<TSetRGTimeoutResponse> => {
    const { $authApi } = useTypedNuxtApp();

    try {
      return await $authApi.post<TSetRGTimeoutResponse>('/responsiblegaming/createRGTimeout', {
        sessionKey: await stores.user.getIdToken(),
        minutesFromNow,
      });
    } catch (error) {
      return {
        hasError: true,
        message: error?.message?.toString() || 'Timeout setting failed',
      };
    }
  };

  return {
    timeoutTimestamp,

    getDepositLimit,
    setDepositLimit,
    getPlayTimeout,
    setPlayTimeout,
  };
}
